// import { createSelector } from 'reselect';

export const getWaivers = (state:any) => state.waiver.waivers;
export const getWaiver = (state:any) => state.waiver.waiver;
export const getIsLoading = (state:any) => state.waiver.isLoading;
export const getStatus = (state:any) => state.waiver.status;
